import { apiClient } from './client';

/** Propósito de un grupo: captura (el bot responde) o supervisión (solo recibe copias). */
export type GroupProposito = 'CAPTURA' | 'SUPERVISION';
export type GroupModoCaptura = 'TODO' | 'SOLO_MENCION';
export type GroupAlcance = 'ROL' | 'RANCHO';
/** Roles que pueden ser el rol de un grupo de supervisión por rol. Valores del enum Role. */
export const SUPERVISION_ROLES = ['FIELD_WORKER', 'WAREHOUSE_MANAGER', 'AGRONOMIST', 'SUPERVISOR', 'AUDITOR'] as const;
export type SupervisionRole = typeof SUPERVISION_ROLES[number];

export interface GroupPropositoInput {
  proposito: GroupProposito;
  modoCaptura?: GroupModoCaptura;
  alcance?: GroupAlcance;
  rol?: SupervisionRole;
}

/** Nivel de copia: 1 todo, 2 filtrado, 3 solo avisos. null = sin copia. */
export type NivelCopia = 1 | 2 | 3 | null;

export interface GroupVigilado {
  userId: string;
  nombre: string;
  nivelCopia: NivelCopia;
  tema: { threadId: number; estado: 'ABIERTO' | 'CERRADO'; nombre?: string } | null;
}

export interface GroupSupervisor {
  nombre: string;
  estado: 'verificado' | 'sin_verificar';
}

export interface GroupVigilados {
  grupo: { chatId: string; label: string; proposito: GroupProposito; alcance: GroupAlcance | null; rol: string | null };
  vigilados: GroupVigilado[];
  supervisores: GroupSupervisor[];
}

export const setGroupProposito = async (chatId: string, input: GroupPropositoInput): Promise<void> =>
  (await apiClient.put(`/api/telegram-groups/${chatId}/proposito`, input)).data;

/** Crea un enlace de invitación con aprobación y lo envía por privado al administrador. */
export const createGroupInvite = async (chatId: string): Promise<{ invite_link: string }> =>
  (await apiClient.post(`/api/telegram-groups/${chatId}/invitacion`)).data;

export const fetchGroupVigilados = async (chatId: string): Promise<GroupVigilados> =>
  (await apiClient.get(`/api/telegram-groups/${chatId}/vigilados`)).data;

export const setUserNivelCopia = async (
  userId: string,
  input: { nivelCopia: NivelCopia; grupoPrincipalId?: string | null },
): Promise<void> =>
  (await apiClient.put(`/api/users/${userId}/nivel-copia`, input)).data;
